export function generateLocalId(list: { localId: number }[]) {
  return Math.max(0, ...list.map(t => t.localId)) + 1;
}
